<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM11,8C10.72,8,10.47,7.89,10.29,7.71C10.29,7.71,9,6.41,9,6.41C9,6.41,9,12,9,12C9,12.55,8.55,13,8,13C7.45,13,7,12.55,7,12C7,12,7,6.41,7,6.41C7,6.41,5.71,7.71,5.71,7.71C5.53,7.89,5.28,8,5,8C4.45,8,4,7.55,4,7C4,6.72,4.11,6.47,4.29,6.29C4.29,6.29,7.29,3.29,7.29,3.29C7.47,3.11,7.72,3,8,3C8.28,3,8.53,3.11,8.71,3.29C8.71,3.29,11.71,6.29,11.71,6.29C11.89,6.47,12,6.72,12,7C12,7.55,11.55,8,11,8C11,8,11,8,11,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Upload',
} as DefineComponent
</script>
